import React, { useState } from 'react';

const faqData = [
  {
    question: 'Хочу на кемп! Проте не маю досвіду 🙂',
    answer:
      'Це чудово! Наш табір створений саме для початківців. Ми навчимо тебе всьому з нуля.',
  },
  {
    question: 'У мене немає ноутбука, що робити?',
    answer:
      'Не хвилюйся! Ми постараємось забезпечити тебе всім необхідним обладнанням на час табору.',
  },
  {
    question: 'Яка тривалість табору та з якої по котру?',
    answer:
      'Табір триває 6 днів, а саме 13 - 18 липня. З 10:00 до 18:00.',
  },
  {
    question: 'Чи забезпечує табір проживання?',
    answer: 'На жаль, ми не можемо надати проживання на час проведення табору. Тому подбайте про це заздалегіть.',
  },
  {
    question: 'Де буде проходити табір?',
    answer: 'Табір буде проходити за адресою: вул. Козельницька, 2а, Львів.',
  },
  {
    question: 'У мене ще питання!',
    answer: 'contacts',
  },
];

export default function QA() {
  const [openIndex, setOpenIndex] = useState(-1);

  const toggleQuestion = (index) => {
    setOpenIndex((currentIndex) =>
      currentIndex === index ? -1 : index
    );
  };

  return (
    <section
      id="qa"
      className="
        relative w-full overflow-hidden
        bg-[#0F081B]
        py-20 md:py-28
        font-['Montserrat'] text-white
      "
    >
      <div
        className="
          container mx-auto
          flex flex-col items-start gap-12
          px-4 sm:px-8 md:px-16
          lg:flex-row lg:gap-20
        "
      >
        {/* Ліва частина */}
        <div className="flex flex-1 flex-col items-start">
          <div className="lg:sticky lg:top-32">
            <p className="mb-3 text-sm font-extrabold uppercase tracking-[0.3em] text-[#3DFF80]">
              Популярні запитання
            </p>

            <h2
              className="
                mb-6 text-6xl font-black
                uppercase leading-none
                sm:text-7xl md:text-8xl
              "
            >
              <span className="text-white">Q&amp;A</span>
            </h2>

            <p className="max-w-md text-lg font-medium leading-relaxed text-white/75 md:text-2xl">
              Тут ми зібрали відповіді на найпоширеніші питання про{' '}
              <span className="font-extrabold text-[#E150A8]">
                APPS Summer Camp
              </span>
              .
            </p>
          </div>
        </div>

        {/* Права частина */}
        <div className="w-full flex-1 lg:max-w-3xl">
          <div className="flex flex-col gap-5">
            {faqData.map((item, index) => {
              const isOpen = openIndex === index;
              const isGreen = index % 2 === 0;

              return (
                <article
                  key={item.question}
                  className={`
                    overflow-hidden rounded-[28px]
                    border-2
                    shadow-[0_16px_45px_rgba(0,0,0,0.25)]
                    transition-all duration-300
                    ${
                      isOpen
                        ? isGreen
                          ? 'border-[#3DFF80]'
                          : 'border-[#E150A8]'
                        : 'border-white/15'
                    }
                  `}
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => toggleQuestion(index)}
                      aria-expanded={isOpen}
                      aria-controls={`faq-answer-${index}`}
                      className={`
                        flex w-full items-center justify-between
                        gap-4 px-5 py-5
                        text-left text-base font-extrabold
                        transition-colors duration-300
                        sm:px-7 sm:py-6 sm:text-lg
                        md:text-xl
                        ${
                          isOpen
                            ? isGreen
                              ? 'bg-[#3DFF80] text-[#0F081B]'
                              : 'bg-[#E150A8] text-[#0F081B]'
                            : 'bg-[#170D27] text-white hover:bg-[#211237]'
                        }
                      `}
                    >
                      <span>{item.question}</span>

                      <span
                        aria-hidden="true"
                        className={`
                          flex h-10 w-10 shrink-0
                          items-center justify-center
                          rounded-full border-2
                          text-2xl font-black
                          transition-transform duration-300
                          ${
                            isOpen
                              ? 'rotate-180 border-[#0F081B] bg-[#0F081B] text-white'
                              : isGreen
                                ? 'border-[#3DFF80] text-[#3DFF80]'
                                : 'border-[#E150A8] text-[#E150A8]'
                          }
                        `}
                      >
                        {isOpen ? '−' : '+'}
                      </span>
                    </button>
                  </h3>

                  {isOpen && (
                    <div
                      id={`faq-answer-${index}`}
                      className="
                        bg-[#170D27]
                        px-5 pb-6 pt-5
                        sm:px-7 sm:pb-7
                      "
                    >
                      {item.answer === 'contacts' ? (
                        <div className="text-base leading-relaxed text-white/80 sm:text-lg">
                          <p>
                            Ми з радістю відповімо на решту твоїх питань!
                          </p>

                          <p className="mt-4">
                            Напиши нам на електронну пошту:
                          </p>

                          <a
                            href="mailto:appscamp@ucu.edu.ua?subject=APPS%20Summer%20Camp%20-%20питання"
                            className="
                              mt-3 inline-flex
                              break-all rounded-full
                              bg-[#3DFF80]
                              px-4 py-2
                              font-extrabold text-[#0F081B]
                              transition-transform
                              hover:-translate-y-1
                            "
                          >
                            appscamp@ucu.edu.ua
                          </a>

                          <p className="mt-5">
                            Або напиши нам в Instagram:
                          </p>

                          <a
                            href="https://instagram.com/apps.camp.ucu"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="
                              mt-3 inline-flex rounded-full
                              bg-[#E150A8]
                              px-4 py-2
                              font-extrabold text-[#0F081B]
                              transition-transform
                              hover:-translate-y-1
                            "
                          >
                            @apps.camp.ucu
                          </a>
                        </div>
                      ) : (
                        <p className="text-base leading-relaxed text-white/80 sm:text-lg">
                          {item.answer}
                        </p>
                      )}
                    </div>
                  )}
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
